export const AREA_RATES_SEARCH = 'Area Rates Search';

export const ZIP_CODE = 'Zip Code';
export const STATE = 'State';

export const ATTEND_A_HOUSE_OF_WORSHIP = 'Attend A House Of Worship?';
export const SEARCH_BY_EMPLOYMENT_AREA = 'Search By Employment Area?';

export const ESTIMATE_VALUE = 'Estimate Value';

export const LOAN_AMOUNT = 'Loan Amount';

export const CHECK_RATES = 'Check Rates';
export const RESET = 'Reset';

export const ALABAMA = 'Alabama';
export const AL = 'AL';

export const ALASKA = 'Alaska';
export const AK = 'AK';

export const ARIZONA = 'Arizona';
export const AZ = 'AZ';

export const ARKANSAS = 'Arkansas';
export const AR = 'AR';

export const CALIFORNIA = 'California';
export const CA = 'CA';

export const COLORADO = 'Colorado';
export const CO = 'CO';

export const CONNECTICUT = 'Connecticut';
export const CT = 'CT';

export const DELAWARE = 'Delaware';
export const DE = 'DE';

export const FLORIDA = 'Florida';
export const FL = 'FL';

export const GEORGIA = 'Georgia';
export const GA = 'GA';

export const HAWAII = 'Hawaii';
export const HI = 'HI';

export const IDAHO = 'Idaho';
export const ID = 'ID';

export const ILLINOIS = 'Illinois';
export const IL = 'IL';

export const INDIANA = 'Indiana';
export const IN = 'IN';

export const IOWA = 'Iowa';
export const IA = 'IA';

export const KANSAS = 'Kansas';
export const KS = 'KS';

export const KENTUCKY = 'Kentucky';
export const KY = 'KY';

export const LOUISIANA = 'Louisiana';
export const LA = 'LA';

export const MAINE = 'Maine';
export const ME = 'ME';

export const MARYLAND = 'Maryland';
export const MD = 'MD';

export const MASSACHUSETTS = 'Massachusetts';
export const MA = 'MA';

export const MICHIGAN = 'Michigan';
export const MI = 'MI';

export const MINNESOTA = 'Minnesota';
export const MN = 'MN';

export const MISSISSIPPI = 'Mississippi';
export const MS = 'MS';

export const MISSOURI = 'Missouri';
export const MO = 'MO';

export const MONTANA = 'Montana';
export const MT = 'MT';

export const NEBRASKA = 'Nebraska';
export const NE = 'NE';

export const NEVADA = 'Nevada';
export const NV = 'NV';

export const NEW_HAMPSHIRE = 'New Hampshire';
export const NH = 'NH';

export const NEW_JERSEY = 'New Jersey';
export const NJ = 'NJ';

export const NEW_MEXICO = 'New Mexico';
export const NM = 'NM';

export const NEW_YORK = 'New York';
export const NY = 'NY';

export const NORTH_CAROLINA = 'North Carolina';
export const NC = 'NC';

export const NORTH_DAKOTA = 'North Dakota';
export const ND = 'ND';

export const OHIO = 'Ohio';
export const OH = 'OH';

export const OKLAHOMA = 'Oklahoma';
export const OK = 'OK';

export const OREGON = 'Oregon';
export const OR = 'OR';

export const PENNSYLVANIA = 'Pennsylvania';
export const PA = 'PA';

export const RHODE_ISLAND = 'Rhode Island';
export const RI = 'RI';

export const SOUTH_CAROLINA = 'South Carolina';
export const SC = 'SC';

export const SOUTH_DAKOTA = 'South Dakota';
export const SD = 'SD';

export const TENNESSEE = 'Tennessee';
export const TN = 'TN';

export const TEXAS = 'Texas';
export const TX = 'TX';

export const UTAH = 'Utah';
export const UT = 'UT';

export const VERMONT = 'Vermont';
export const VT = 'VT';

export const VIRGINIA = 'Virginia';
export const VA = 'VA';

export const WASHINGTON = 'Washington';
export const WA = 'WA';

export const WEST_VIRGINIA = 'West Virginia';
export const WV = 'WV';

export const WISCONSIN = 'Wisconsin';
export const WI = 'WI';

export const WYOMING = 'Wyoming';
export const WY = 'WY';

export const STATE_OPTIONS = [
  { text: ALABAMA, value: AL },
  { text: ALASKA, value: AK },
  { text: ARIZONA, value: AZ },
  { text: ARKANSAS, value: AR },
  { text: CALIFORNIA, value: CA },
  { text: COLORADO, value: CO },
  { text: CONNECTICUT, value: CT },
  { text: DELAWARE, value: DE },
  { text: FLORIDA, value: FL },
  { text: GEORGIA, value: GA },
  { text: HAWAII, value: HI },
  { text: IDAHO, value: ID },
  { text: ILLINOIS, value: IL },
  { text: INDIANA, value: IN },
  { text: IOWA, value: IA },
  { text: KANSAS, value: KS },
  { text: KENTUCKY, value: KY },
  { text: LOUISIANA, value: LA },
  { text: MAINE, value: ME },
  { text: MARYLAND, value: MD },
  { text: MASSACHUSETTS, value: MA },
  { text: MICHIGAN, value: MI },
  { text: MINNESOTA, value: MN },
  { text: MISSISSIPPI, value: MS },
  { text: MISSOURI, value: MO },
  { text: MONTANA, value: MT },
  { text: NEBRASKA, value: NE },
  { text: NEVADA, value: NV },
  { text: NEW_HAMPSHIRE, value: NH },
  { text: NEW_JERSEY, value: NJ },
  { text: NEW_MEXICO, value: NM },
  { text: NEW_YORK, value: NY },
  { text: NORTH_CAROLINA, value: NC },
  { text: NORTH_DAKOTA, value: ND },
  { text: OHIO, value: OH },
  { text: OKLAHOMA, value: OK },
  { text: OREGON, value: OR },
  { text: PENNSYLVANIA, value: PA },
  { text: RHODE_ISLAND, value: RI },
  { text: SOUTH_CAROLINA, value: SC },
  { text: SOUTH_DAKOTA, value: SD },
  { text: TENNESSEE, value: TN },
  { text: TEXAS, value: TX },
  { text: UTAH, value: UT },
  { text: VERMONT, value: VT },
  { text: VIRGINIA, value: VA },
  { text: WASHINGTON, value: WA },
  { text: WEST_VIRGINIA, value: WV },
  { text: WISCONSIN, value: WI },
  { text: WYOMING, value: WY },
];

export const state_rates_filter = 'state';
export const zip_code_rates_filter = 'zip_code';

export const REBUILDING = 'Rebuilding';
export const FAIR = 'Fair';
export const GOOD = 'Good';
export const EXCELLENT = 'Excellent';

export const CREDIT_SCORE_OBJ = {
  [REBUILDING]: 640,
  [FAIR]: 675,
  [GOOD]: 725,
  [EXCELLENT]: 800,
};

export const REBUILDING_SCORE = '<640';
export const FAIR_SCORE = '641-699';
export const GOOD_SCORE = '700-749';
export const EXCELLENT_SCORE = '750-850';

export const EDIT = 'Edit';

export const SELECT_EMPLOYER_PROGRAMS = 'Select Employer Programs';
export const QUORUM_SEG_TITLE = "Quorum Federal Credit Union's Select Employer Program";
